import _styled from "@emotion/styled-base";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __spreadArrays = this && this.__spreadArrays || function () {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) {
    s += arguments[i].length;
  }

  for (var r = Array(s), k = 0, i = 0; i < il; i++) {
    for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) {
      r[k] = a[j];
    }
  }

  return r;
};

import React from 'react';
import ReactDOM from 'react-dom';
import { jsx } from '@emotion/core';
import { BannerAlert } from '../BannerAlert';
import { FONT, PADDING } from '../../constants';
import { zIndexLevels } from '../../internalConstants';
var globalAlertHeight = 60;

var StyledGlobalAlert =
/*#__PURE__*/
_styled(BannerAlert, {
  target: "e13kqd660",
  label: "StyledGlobalAlert"
})(__assign(__assign({
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  boxSizing: 'border-box',
  height: globalAlertHeight,
  zIndex: zIndexLevels.globalAlert,
  margin: 0,
  padding: PADDING.tiny,
  borderRadius: 0
}, FONT.sizes.regular), {
  transition: 'opacity 0.3s, transform 0s 0.4s',
  justifyContent: 'center',
  alignItems: 'center',
  textAlign: 'center',
  '& button': {
    top: '50%',
    transform: 'translateY(-50%)'
  },
  '& span': {
    margin: '0 auto'
  }
}), function (props) {
  return {
    opacity: props.isVisible ? 1 : 0,
    pointerEvents: props.isVisible ? 'auto' : 'none',
    transform: props.isVisible ? 'scale(1)' : 'scale(0)'
  };
}, process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");

export var GlobalAlert = function GlobalAlert(_a) {
  var subscribe = _a.subscribe,
      unsubscribe = _a.unsubscribe;

  var _b = React.useState([]),
      queue = _b[0],
      setQueue = _b[1];

  var _c = React.useState(null),
      currentAlert = _c[0],
      setCurrentAlert = _c[1];

  var setInQueue = React.useCallback(function (event) {
    setQueue(__spreadArrays(queue, [event.detail.alert]));
  }, [queue]);
  React.useEffect(function () {
    subscribe(setInQueue);
    return function () {
      unsubscribe(setInQueue);
    };
  }, [setInQueue, subscribe, unsubscribe]);
  React.useEffect(function () {
    if (currentAlert === null && queue.length > 0) {
      var newCurrentAlert = queue[0],
          rest = queue.slice(1);
      setQueue(rest);
      setCurrentAlert(newCurrentAlert);
    }
  }, [currentAlert, queue, setInQueue, unsubscribe]);
  React.useEffect(function () {
    var timeoutReference;

    if (currentAlert) {
      timeoutReference = window.setTimeout(function () {
        setCurrentAlert(null);
      }, currentAlert.timeout || 2000);
    }

    return function () {
      if (timeoutReference) {
        window.clearTimeout(timeoutReference);
      }
    };
  }, [currentAlert]);

  var _d = currentAlert || {},
      _e = _d.appearance,
      appearance = _e === void 0 ? 'info' : _e,
      _f = _d.message,
      message = _f === void 0 ? '' : _f;

  return ReactDOM.createPortal(jsx(StyledGlobalAlert, {
    appearance: appearance,
    isVisible: currentAlert !== null,
    onClose: function onClose() {
      return setCurrentAlert(null);
    },
    closable: true,
    isGlobal: true
  }, message), document.body);
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@trustpilot/businessapp-patternlibrary/lib/components/GlobalAlert/GlobalAlertComponent.js
// module id = 824
// module chunks = 0